class LoadMore extends window.HTMLElement {
  constructor() {
    super();
    this.productsPerPage = 8;
  }
  connectedCallback() {
    this.productsList = this.querySelector(".products-list");
    this.loadMoreButton = this.querySelector(".load-more-button");
    this.loadingState = this.querySelector(".loading-state");
    const initialProductsShown = parseInt(this.dataset.productsToShow) || 8;
    if (!this.currentPage) {
      this.currentPage = Math.ceil(initialProductsShown / this.productsPerPage);
    }
    this.totalProducts = parseInt(this.dataset.totalProducts) || 0;
    if (initialProductsShown >= this.totalProducts) {
      this.hideLoadMoreButton();
    }
    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener(
        "click",
        this.handleLoadMore.bind(this)
      );
    }
  }
  getLoadedProductsCount() {
    return this.productsList ? this.productsList.children.length : 0;
  }
  async handleLoadMore() {
    const collectionHandle = this.dataset.collectionId;
    if (!collectionHandle) {
      console.error("Collection handle is required");
      return;
    }
    this.setLoadingState(true);
    try {
      this.currentPage++;
      const urlParams = new URLSearchParams(window.location.search);
      let url = `/collections/${collectionHandle}?view=ajax&page=${this.currentPage}`;
      for (const [key, value] of urlParams.entries()) {
        if (key !== "view" && key !== "page") {
          url += `&${key}=${encodeURIComponent(value)}`;
        }
      }
      const response = await fetch(url, {
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newProducts = doc.querySelector(".products-list");
      if (newProducts && newProducts.children.length > 0) {
        Array.from(newProducts.children).forEach((child) => {
          this.productsList.appendChild(child);
        });
        const loadedProducts = this.getLoadedProductsCount();
        if (loadedProducts >= this.totalProducts) {
          this.hideLoadMoreButton();
        }
      } else {
        this.hideLoadMoreButton();
      }
    } catch (error) {
      console.error("Error loading more products:", error);
      this.showError();
    } finally {
      this.setLoadingState(false);
    }
  }
  setLoadingState(isLoading) {
    if (this.loadMoreButton) {
      this.loadMoreButton.disabled = isLoading;
    }
    if (this.loadingState) {
      this.loadingState.classList.toggle("hidden", !isLoading);
    }
    if (this.loadMoreButton) {
      const buttonText = this.loadMoreButton.querySelector(".button-text");
      if (buttonText) {
        buttonText.classList.toggle("hidden", isLoading);
      }
    }
  }
  hideLoadMoreButton() {
    const buttonContainer = this.querySelector(".load-more-container");
    if (buttonContainer) {
      buttonContainer.classList.add("hidden");
    } else if (this.loadMoreButton) {
      this.loadMoreButton.classList.add("hidden");
    }
  }
  showError() {
    const errorText = this.querySelector(".error-message");
    if (errorText) {
      errorText.classList.remove("hidden");
    }
    if (this.loadMoreButton) {
      this.loadMoreButton.classList.add("hidden");
    }
  }
}
window.customElements.define("load-more", LoadMore);
